const config = require('../../web-config')

export const APPS = {
  WS: 'ws',
  SSO: 'sso',
  FILE: 'file',
  FYZHMD: 'fyzhmd'
}

export const SERVICES = {
  WEBSITE_CFG: 'srvdaq_pc_website_cfg_select',
  CAROUSEL: 'srvdaq_pc_carousel_select',
  CATEGORY: 'srvdaq_pc_website_category_select',
  CONTENT: 'srvdaq_pc_website_content_select',
  LOGIN: 'srvuser_login',
  LOGOUT: 'srvuser_exit',
  CHECK_MOBILE: 'srvsso_check_mobile',
  SEND_CODE: 'srvsso_send_node',
  RESET_PWD: 'srvsso_reset_pwd',
  USER_RESET_PWD: 'srvsso_user_pwd_reset',
  MEMBER_INFO: 'srvws_member_info_select',
  MEMBER_PAY: 'srvws_member_pay_record_select',
  FILE_SELECT: 'srvfile_attachment_select',
  FILE_DELETE: 'file/delete',
  FRIEND_LINKS: 'srvcms_friend_links_select',
  COLUMNNEX_V2: 'srvsys_service_columnex_v2_select',
  MOBILE_NOTE_SEND: 'srvmobile_note_send',
  EVENT_MGT: 'srvgive_event_mgt_user_select',
  LEAVE_WORD: 'srvgive_leave_word_add'
}

export const OPERATIONS = {
  SELECT: 'select',
  OPERATE: 'operate',
  MULTI: 'multi'
}

const getBaseURL = () => {
  if (process.env.NODE_ENV === 'development') {
    return '/bxapi'
  }
  return `${config.protocol}://${config.host}${config.port ? ':' + config.port : ''}${config.prefix}`
}

export const API_BASE_URL = getBaseURL()

export const HOST = `${config.protocol}://${config.host}${config.port ? ':' + config.port : ''}${config.prefix}`
